import { getMenuBuilderPlanMax } from 'src/constants/menuBuilderPlanLimits'
import { getRecipePlanAllowance } from 'src/constants/recipePlanAllowances'
import { formatRecipesHabitProgress } from './growthEngineHabitProgress'

export const isLimitedMenuBuilderPlan = currentPlan =>
  getMenuBuilderPlanMax(currentPlan) != null

export const isFreeMenuBuilderPlan = currentPlan =>
  (String(currentPlan || '')
    .trim()
    .toLowerCase() || 'free') === 'free'

export const getMenuBuilderLimitStats = ({
  recipeCount = 0,
  currentPlan = 'Free',
} = {}) => {
  const { storeMax, monitorMax } = getRecipePlanAllowance(currentPlan)
  const used = recipeCount
  const remaining = storeMax == null ? null : Math.max(0, storeMax - used)
  const atLimit = storeMax != null && used >= storeMax

  return {
    planMax: storeMax,
    monitorMax,
    used,
    remaining,
    atLimit,
    isLimitedPlan: storeMax != null,
  }
}

export const formatSlotsUsedCompact = (used, planMax, currentPlan = 'Free') =>
  formatRecipesHabitProgress(used, planMax, {
    isFree: isFreeMenuBuilderPlan(currentPlan),
  })

export const formatSlotsRemainingShort = remaining => {
  if (remaining === 2) {
    return '2 left'
  }
  if (remaining === 1) {
    return '1 left'
  }
  return null
}

export const getMenuBuilderLimitWarning = ({
  remaining,
  atLimit = false,
  currentPlan = 'Free',
}) => {
  if (!isLimitedMenuBuilderPlan(currentPlan)) {
    return null
  }

  if (atLimit || remaining === 0) {
    return null
  }

  return formatSlotsRemainingShort(remaining)
}

export const getMenuBuilderLimitDisplay = ({
  recipeCount = 0,
  currentPlan = 'Free',
} = {}) => {
  const stats = getMenuBuilderLimitStats({
    recipeCount,
    currentPlan,
  })

  const showLimitUi = stats.monitorMax != null || stats.isLimitedPlan
  if (!showLimitUi) {
    return {
      ...stats,
      showLimitUi: false,
      slotsUsedText: null,
      warningText: null,
      progress: 0,
    }
  }

  const progress =
    stats.monitorMax > 0 ? Math.min(1, stats.used / stats.monitorMax) : 0
  const warningText = getMenuBuilderLimitWarning({
    remaining: stats.remaining,
    atLimit: stats.atLimit,
    currentPlan,
  })

  return {
    ...stats,
    showLimitUi: true,
    slotsUsedText: formatSlotsUsedCompact(
      stats.used,
      stats.monitorMax,
      currentPlan,
    ),
    warningText,
    progress: Math.min(1, Math.max(0, progress)),
  }
}
